import React from 'react'

export default function H3({ children, className = '' }) {
  return (
    <h3 className={`text-[21px] lg:text-2xl font-semibold leading-tight ${className}`}>{children}</h3>
  )
}
